import ConfettiGenerator from 'confetti-js';

function Ctrl($scope, $state, metaTagService, utilsService) {
  if (!$scope.isSubscribed()) {
    $state.go('app.membership.landing');

    return;
  }

  const url = utilsService.createUrl(`/membership?promo=${$scope.currentUser.referralCode}`);

  console.log('url', url);

  $scope.facebookLink = utilsService.facebookLink(url);

  console.log('$scope.facebookLink', $scope.facebookLink);

  const confettiSettings = {
    target: 'confetti-canvas',
    max: '100',
    animate: true,
    props: ['square', 'triangle', 'line'],
    colors: [
      [165, 104, 246],
      [230, 61, 135],
      [0, 199, 228],
      [253, 214, 126]
    ],
    clock: '10',
    rotate: false
  };
  const confetti = new ConfettiGenerator(confettiSettings);

  confetti.render();

  metaTagService.set({
    title: 'Thank You | Tablelist',
    description: 'Receive exclusive member only perks and experiences at your favorite nightclubs, lounges, and events.'
  });

  $scope.onCopied = function() {
    document.getElementById('referral-code').select();
  };
}

Ctrl.$inject = [
  '$scope',
  '$state',
  'metaTagService',
  'utilsService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/membershipSuccess/membershipSuccessCtrl.js